import { render, staticRenderFns } from "./GlobalLoaderTrigger.vue?vue&type=template&id=451fdbb4&"
import script from "./GlobalLoaderTrigger.vue?vue&type=script&lang=js&"
export * from "./GlobalLoaderTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports